export default "__VITE_ASSET__KaZMSf9M__"